<app-policy-change-confirmation-dialog
    #confirmation
    [timeOffPolicy]="timeOffPolicy"
></app-policy-change-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ 'time-off-v3.editPolicy.editTimeOffPolicyName' | translate: { name: timeOffPolicy.name } }}"
        [back]="true"
    ></app-header>

    <form #form="ngForm" invalidControlScroll>
        <app-accrual-settings-update-card
            #accrualSettings
            [timeOffPolicy]="timeOffPolicy"
        ></app-accrual-settings-update-card>

        <ng-container *ngIf="!timeOffPolicy.isUnlimited && timeOffPolicy.isUnlimited !== undefined">
            <app-amount-accrued-per-year-update-card
                #amountAccruedPerYear
                [timeOffPolicy]="timeOffPolicy"
                [unitOfTime]="timeOffPolicy.timeOffType.unitOfTimePluralTranslation"
            ></app-amount-accrued-per-year-update-card>
            <app-accrual-schedule-update-card
                #accrualSchedule
                [timeOffPolicy]="timeOffPolicy"
            ></app-accrual-schedule-update-card>
            <app-carryover-update-card #carryover [timeOffPolicy]="timeOffPolicy"></app-carryover-update-card>
            <app-maximum-accrued-balance-update-card
                #maximumAccruedBalance
                [timeOffPolicy]="timeOffPolicy"
            ></app-maximum-accrued-balance-update-card>
        </ng-container>
    </form>

    <div class="buttons flex flex-end">
        <ui-button type="ghost" (click)="onCancel()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSave()">{{ 'save' | translate }}</ui-button>
    </div>
</div>
